export default "__VITE_ASSET__CYro1DOF__"